import * as React from "react"
import { Link } from "gatsby"

const CvButton = ({ primaryLabel, Color, href, secondaryLabel }) => {
  let primaryColor

  switch (Color) {
    case "Red":
      primaryColor = "primary-red"
      break
    case "Black":
      primaryColor = "primary-black"
      break
    case "Navy":
      primaryColor = "primary-navy"
      break
    case "Beige":
      primaryColor = "primary-beige"
      break
    case "Transparent":
      primaryColor = "primary-transparent"
      break
    default:
      primaryColor = "primary-red"
  }

  return (
    <div className="primary_btn">
      {secondaryLabel && (
        <div
          className={`primary_btn__balloon balloon_animation ${primaryColor}`}
        >
          <p>{secondaryLabel}</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="11"
            viewBox="0 0 19 11"
            className="balloon-tail"
          >
            <g filter="url(#filter0_di_3090_997)">
              <path d="M0.5 2H18.5L10.9142 9.58579C10.1332 10.3668 8.86683 10.3668 8.08579 9.58579L0.5 2Z" />
            </g>
            <defs>
              <filter
                id="filter0_di_3090_997"
                x="0.5"
                y="0"
                width="18"
                height="10.1716"
                filterUnits="userSpaceOnUse"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="-2" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_3090_997"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_3090_997"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="-3" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.854902 0 0 0 0 0.215686 0 0 0 0 0.203922 0 0 0 1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect2_innerShadow_3090_997"
                />
              </filter>
            </defs>
          </svg>
        </div>
      )}
      <Link to={href}>
        <div className={`primary_btn__wrapper  ${primaryColor}`}>
          <div className="primary_btn__inner">
            <p className="primary_btn__label">{primaryLabel}</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 16 16"
              fill="none"
              className="arrow"
            >
              <path
                d="M11.0533 7.33398L7.8602 4.14086C7.6002 3.88086 7.6002 3.46086 7.8602 3.20086C8.1202 2.94086 8.5402 2.94086 8.8002 3.20086L13.0709 7.47155C13.2301 7.59367 13.3332 7.7857 13.3332 8.00065C13.3332 8.19555 13.2484 8.37161 13.1139 8.4938L8.8002 12.8075C8.66775 12.94 8.5024 13.0001 8.33029 13.0009C8.15812 13 7.9927 12.9334 7.8602 12.8075C7.6002 12.5475 7.6002 12.1275 7.8602 11.8675L11.0604 8.66732H3.33317C2.9665 8.66732 2.6665 8.36732 2.6665 8.00065C2.6665 7.63398 2.9665 7.33398 3.33317 7.33398H11.0533Z"
                fill="#fff"
              />
              <path
                d="M8.33029 13.0009L8.33354 13.0009H8.32687L8.33029 13.0009Z"
                fill="#fff"
              />
            </svg>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default CvButton
